@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.scrollToTopButtonWrapper {
  position: absolute;
  bottom:  hevo-toolkit-variables.$spacer * 1.25;
  right:  hevo-toolkit-variables.$spacer * 1.25;
  z-index:  hevo-toolkit-variables.$zindex-fab;

  .scrollToTopButton {
    padding:  hevo-toolkit-variables.$spacer * 0.25;
    color:  hevo-toolkit-variables.$light-text;
    background-color:  hevo-toolkit-variables.$primary;
    border: none;
    border-radius: 50%;
    outline: none;
    display: flex;
    cursor: pointer;
    opacity: 1 !important;
    box-shadow:  hevo-toolkit-variables.$shadow-default;
    transition: all 0.2s ease;

    &:hover,
    &:focus {
      background-color:  hevo-toolkit-variables.$primary-dark !important;
      box-shadow:  hevo-toolkit-variables.$shadow-elevated-primary !important;
    }

    .icon {
      color:  hevo-toolkit-variables.$light-text;
    }
  }

  &.hidden {
    display: none;
  }
}
